import React from 'react'
import BaseCheckbox from '@material-ui/core/Checkbox'
import PropTypes from 'prop-types'

/**
 * The `Checkbox` component wrap https://material-ui.com/components/checkboxes/.
 *
 *
 * Only important or basic options has been added in propTypes.
 * You can still use the other features of material-ui if supported by the current version of our design system.
 *
 * Using or adding new options that is not on the propTypes please notify the Front-End Architect
 */

const Checkbox = props => {
  const { children, ...rest } = props
  return <BaseCheckbox data-cid='Checkbox-root' {...rest} />
}

Checkbox.propTypes = {
  /**
   * Use the naming standards.
   */
  id: PropTypes.string.isRequired,
  /**
   Callback fired when the state is changed.

   Signature:
   function(event: object) => void
   event: The event source of the callback. You can pull out the new checked state by accessing event.target.checked (boolean).
   */
  onChange: PropTypes.func,
  /** Attributes applied to the input element.
   *
   * aria-label: is required
   */
  inputProps: PropTypes.object.isRequired,
  /** The color of the component. It supports those theme colors that make sense for this component. */
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),
  /** If true, the component is checked. */
  checked: PropTypes.bool,
  /** If true, the button will be disabled. */
  disabled: PropTypes.bool,
  /** If true, the input element will be required. */
  required: PropTypes.bool,
  /** The value of the component. The DOM API casts this to a string. */
  value: PropTypes.any,
  /** The size of the checkbox. small is equivalent to the dense checkbox styling. */
  size: PropTypes.oneOf(['small', 'medium'])
}

Checkbox.defaultProps = {
  color: 'secondary',
  disabled: false,
  size: 'medium'
}

export default Checkbox
